import { createSlice } from "@reduxjs/toolkit";

const initialWarehouseState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    warehouseForEdit: undefined,
    lastError: null,
    message: null,
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const warehouseSlice = createSlice({
    name: "warehouses",
    initialState: initialWarehouseState,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error.clientMessage;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            state.message = null;

            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            state.message = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        // getWarehouseById
        warehouseFetched: (state, action) => {
            state.actionsLoading = false;
            state.warehouseForEdit = action.payload.warehouseForEdit;
            state.floorPlans = action.payload.warehouseForEdit.floorPlans;
            state.error = null;

        },
        // getWarehouseChart
        warehouseChartFetched: (state, action) => {

            state.actionsLoading = false;
            state.warehouseChart = action.payload.warehouseChart;
            state.error = null;

        },
        // getWarehouseChart
        warehouseHourlyChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.warehouseChartHour = action.payload.warehouseChartHour;
            state.error = null;

        },
        // getWarehouseChart
        warehouseHourlyZoneChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.warehouseChartHourZone = action.payload.warehouseChartHourZone;
            state.error = null;

        },
        // get list data
        warehousesFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
            state.warehouseForEdit = undefined;
            state.floorPlans = undefined;
            state.warehouseChart = undefined;
            state.warehouseChartHour = undefined;
            state.warehouseChartHourZone = undefined;
        },
        // createWarehouse
        warehouseCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        // updateWarehouse
        warehouseUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.message = action.payload.msgResponse;
        },
        // warehouseDeleted
        warehouseDeleted: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
            state.actionsLoading = false;
        },
        setMessage: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        floorPlanDeleted: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.floorPlans = state.floorPlans.filter(item => item.id !== action.payload.id);
        },
        floorPlanUpdated: (state, action) => {
            const { id, floorPlan } = action.payload;
            state.error = null;
            state.actionsLoading = false;
            state.floorPlans = state.floorPlans.map((data) => {

                if (data.id === id) {
                    return floorPlan;
                }

                return data;
            });
        }

    }
});
